var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7V7.5H9H15C15.1326 7.5 15.2598 7.55268 15.3536 7.64645C15.4473 7.74021 15.5 7.86739 15.5 8C15.5 8.13261 15.4473 8.25979 15.3536 8.35355C15.2598 8.44732 15.1326 8.5 15 8.5H9H8.5V9V15C8.5 15.1326 8.44732 15.2598 8.35355 15.3536C8.25979 15.4473 8.13261 15.5 8 15.5C7.86739 15.5 7.74021 15.4473 7.64645 15.3536C7.55268 15.2598 7.5 15.1326 7.5 15V9V8.5H7H1C0.867392 8.5 0.740215 8.44732 0.646447 8.35355C0.552678 8.25978 0.5 8.13261 0.5 8C0.5 7.86739 0.552678 7.74022 0.646447 7.64645C0.740215 7.55268 0.867392 7.5 1 7.5H7H7.5V7V1C7.5 0.867392 7.55268 0.740215 7.64645 0.646447C7.74022 0.552678 7.86739 0.5 8 0.5C8.13261 0.5 8.25978 0.552678 8.35355 0.646447C8.44732 0.740215 8.5 0.867392 8.5 1V7Z",
    stroke: "#CBD5E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.838d40fa7450d279f5f8f2e9e4664c1e.svg";
export { ForwardRef as ReactComponent };